<template>
  <div class="page_israGud">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">客户名称</div>
            <el-input v-model="listQuery.CustomeName" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">业务类型</div>
            <el-select v-model="listQuery.BusiType" placeholder="" size="small" clearable>
              <el-option label="外包" value="外包"></el-option>
              <el-option label="派遣" value="派遣"></el-option>
              <el-option label="代理招聘" value="代理招聘"></el-option>
              <el-option label="猎头" value="猎头"></el-option>
            </el-select>
          </div>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{showDropScreen==1 ? '收起':'更多'}}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen==-1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen==1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="94px">
          <el-form-item label="客户地区:">
            <el-input v-model="listQuery.CustomeArea" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户行业:" label-width="68px">
            <!-- <el-select v-model="listQuery.CustomerIndustry" size="small" placeholder="" clearable>
              <el-option label="是" value="是"></el-option>
              <el-option label="否" value="否"></el-option>
            </el-select> -->
            <el-input v-model="listQuery.CustomerIndustry" size="small" clearable></el-input>
          </el-form-item>

        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen=-1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>业务指南</el-breadcrumb-item> <el-breadcrumb-item>信息维护</el-breadcrumb-item>
          <el-breadcrumb-item>文档管理</el-breadcrumb-item>
          <el-breadcrumb-item>客户案例</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="案例管理" name="/successCaseSet"></el-tab-pane>
          <el-tab-pane label="合同模板管理" name="/contractTemplateSet"></el-tab-pane>
          <el-tab-pane label="报价体系" name="/quotationGuiSet"></el-tab-pane>
          <!-- <el-tab-pane label="三体系认证" name="/threeSystem"></el-tab-pane> -->
          <el-tab-pane label="公司介绍" name="/companyProfileSet"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;">
          <el-button type="success" size="small" @click="addCase('')">&nbsp;新增</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width: 1471px;">
          <el-table-column prop="SerialNumber" label="序号" width="50" align="center">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <el-table-column prop="CustomeName" label="客户" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CustomeArea" label="客户地区" width="180" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.CustomeArea ? scope.row.CustomeArea.replace(/,/g,'-') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="CustomerIndustry" label="客户行业" width="120" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.CustomerIndustry ? scope.row.CustomerIndustry.replace(/,/g,'-') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="ContractSubjectName" label="主体名称" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="BusiType" label="业务类型" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CooperationTime" label="合作开始时间" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="scope">
              {{ scope.row.CooperationTime ? scope.row.CooperationTime.split('T')[0] : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="CooperationStue" label="当前状态" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Details" label="说明" width="240" align="center" :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="附件" width="100" align="center" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="info_item_sys cp" v-if="scope.row.DetailsUrl" @click="down(scope.row.DetailsUrl,scope.row.DetailsFileName)">{{ scope.row.DetailsFileName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed="right">
            <template slot-scope="scope">
              <span class="info_item_sys cp" @click="addCase(scope.row)">编辑</span>
              <span class="info_item_sys cp" style="margin-left: 10px;" @click="del(scope.row)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import xz from "../../common";
  export default {
    data() {
      return {
        tableHeight: 0,
        showDropScreen: -1, //筛选下拉框 
        listQuery: {
          CustomeName:'',//客户名称
          BusiType: '',//业务类型
          CustomeArea: '',//客户地区
          CustomerIndustry: '',//客户行业
          pageNum: 1,
          pageSize: "10"
        },
        totalCount:0,
        tableData: [],
        activeName:'/successCaseSet',
        headPath: this.$store.state.EMP.docPath,
        loading:false,
      };
    },
    created() {
      this.calHeight();
      this.getcustomecaselist();
    },
    methods: {
      calHeight() {
        this.tableHeight = Number(document.body.clientHeight);
      },
      //获取案例列表
      getcustomecaselist() {
        this.loading = true;
        xz.getcustomecaselist(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.$message.error('系统出错')
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getcustomecaselist();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getcustomecaselist();
      },
      // 清空
      resetHandle() {
        this.listQuery = this.$options.data.call(this).listQuery;
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
      searchHandle() {
        this.getcustomecaselist()
      },
      //查看详情
      toDdetail() {
        this.$router.push({
          path: '/legalSubjectInfo'
        })
      },
      handleClick(){
        this.$router.push({
          path:this.activeName
        })
      },
      addCase(row){
        this.$router.push({
          path: "/addCase",
          query: {
            row: row ? JSON.stringify(row) : ''
          },
        });
      },
      del(row) {
        this.$set(row, 'IsDeleted', 1)
        xz.updatecustomecase(row).then(res => {
          if (res.status == 'ok') {
            this.getcustomecaselist()
            this.$message.success('删除成功')
          } else {
            this.$message.error('系统出错')
          }
        })
      },
      down(url,name) {
        let d = url.replace("\"", "").replace("\"", "");
        var path = this.headPath + d;
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.setAttribute('download', name);
        aTag.click();
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    width: 98%;
    margin-bottom: 16px;
  }

  .info_item_sys {
    color: #598DE7;
  }
</style>
<style>
  .page_israGud .el-table .ascending .sort-caret.ascending {
    border-bottom-color: #c0c4cc;
  }

  .page_israGud .el-table .descending .sort-caret.descending {
    border-top-color: #c0c4cc;
  }

  .page_israGud .th_input_label .el-form-item__label {
    width: 66px !important;
  }

  .page_israGud .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .page_israGud .el-tabs {
    background-color: #fff;
    padding: 0 10px;
  }

  .page_israGud .screenInputs .screenInput {
    margin: 0 0 10px 5px;
  }

  .page_israGud .screenInputs .screenInput .el-select .el-input__inner,
  .page_israGud .re_down_form.el-form--inline .el-form-item__content,
  .page_israGud .re_down_form .el-select,
  .page_israGud .re_down_form .el-form-item__content,
  .page_israGud .screenInput .el-input {
    width: 200px !important;
  }

  /* .doc_table.el-table .cell {
    padding: 0 5px;
  } */

  .page_israGud .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_israGud .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }


  .page_israGud .r_dropDownScreen .el-select .el-input .el-select__caret {
    line-height: 40px;
  }
</style>